<template>
  <div>
    <div class="mt-5 mb-2 d-flex flex-wrap justify-content-between align-items-center">
      <h1 class="ang-heading">Analiza potrzeb ubezpieczeniowych</h1>
      <div class="ang-user" v-show="in_progress !== false">
        <span class="mr-1">Dla</span>
        <span>{{client.company_name}}</span>
        <span v-if="!client.company_name">{{client.first_name}} {{client.last_name}}</span>
      </div>
    </div>
    <div v-if="loading" class="mt-5">
      <spinner position="center"></spinner>
    </div>
    <div v-show="!loading ">
      <div v-if="in_progress">
        <div v-show="agree < 2">
          <h3 class="ang-heading mt-5">Określ czy wrażasz zgodę na analizę potrzeb</h3>
          <div class="row">
            <div class="col-md-6 d-flex align-items-stretch"
                 :class="{'selected' : agree === 1, 'dimmed' : agree === 0 }">
              <div class="ang-card card-icon-bg card-icon-bg-primary o-hidden mb-30 text-center">
                <div class="ang-card-body d-flex flex-column ang-body-regulations"
                     @click="nextStep()">
                    <p>Wyrażam zgodę na przeprowadzenie analizy potrzeb ubezpieczeniowych</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex align-items-stretch"
                 :class="{'o-hidden' : agree === 0, 'selected' : agree === 0, 'dimmed' : agree === 1 }">
              <div class="ang-card card-icon-bg card-icon-bg-primary mb-30 text-center"
                   @click="clear()">
                <div class="ang-card-body d-flex flex-column ang-body-regulations">
                  <p>Odmawiam wypełnienia analizy potrzeb ubezpieczeniowych (Analiza Potrzeb Klienta, APK). Odmowa wiąże się z brakiem możliwości przedstawnienia oferty ubezpieczeniowej przez Eksperta</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <insuranceTypes v-show="agree === 1" :agree="agree" @selectedInsurancesTypes="selectedInsurancesTypes"/>
        <insuranceTypesList :agree="agree" :client="client" :uid="uid" :base="base" :insurances="insurances" :prevent="prevent" @backward="agree--" @forward="in_progress = false"/>
        <div class="deco-2">
          <svg width="291" height="301" class="parallax-move" data-depth="0.4"
               xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290.8 301.08">
            <path
                d="M181.24 268.83c-31.74-6.2-50.08 15.86-62.26 7.02-11.8-8.57 3.2-30.91-9.95-48.42-12.47-16.6-33.28-6.33-53.6-20.08-27.6-18.68-39.29-71.48-20.51-94.07 24.06-28.93 89.26 2.43 106.9-26.45 9.81-16.07-6.37-32.26 3.89-45.48 17.77-22.9 93.16-8.8 102.43 21.79 7.87 26-38.3 43.14-34.86 82.29 3.09 35.18 42.11 41.11 41.82 75.45-.23 27.1-24.82 55.31-46.76 56.6-10.66.64-11.66-5.63-27.1-8.65z"
                fill="#FFD433"></path>
          </svg>
        </div>
        <div v-show="agree === 1 || agree === 2" class="deco-4">
          <svg class="parallax-move" data-depth="0.4" height="226.12" viewBox="0 0 222.922 226.12"
               width="222.922" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M152.318 155.231c-8.283 6.18-21.242 2.146-37.635-3.187-25.472-8.286-23.941-14.048-35.653-14.508-20.199-.793-26.436 16.274-46.978 13.665-2.8-.356-15.594-1.979-20.159-10.578-7.85-14.792 11.33-45.223 36.242-55.391 12.282-5.014 23.97-4.294 44.123-3.05 27.015 1.667 35.371 7.761 46.188 1.495 13.407-7.766 9.779-22.462 20.207-26.726 19.37-7.923 60.748 30.97 54.278 48.263-5.292 14.117-39.544 5.884-51.77 28.451-5.162 9.53-2.022 16.48-8.843 21.566z"
                fill="#11A68A"></path>
          </svg>
        </div>
      </div>
      <div v-else class="ang-card">
        <div class="ang-card-body">
          <div class="alert alert-success ang-alert-success mt-3">
            <h5 class="ang-card-title">Dziękujemy za wypełnienie formularza Analizy Potrzeb Klienta</h5>
            <div>
              Na Twój e-mail wysłaliśmy potwierdzenie wypełnienie niniejszego formularza.<br/>
              Masz pytania? Skontaktuj się z Ekspertem ANG
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/services/api'
import spinner from "@/components/partials/misc/spinner"
import insuranceTypes from '@/components/partials/apk/insuranceTypes'
import insuranceTypesList from "@/components/partials/apk/insuranceTypesList"
import moment from 'moment'
import tippy from "tippy.js"

export default {
  data () {
    return {
      loading: false,
      agree: null,
      in_progress: true,
      uid: undefined,
      insurances: [],
      prevent: false,
      client: {},
      base: null
    }
  },
  name: "apkForm",
  components: {
    spinner,
    insuranceTypes,
    insuranceTypesList
  },
  mounted () {
    let self = this
    if (typeof this.$route.params.base !== 'undefined') {
      this.base = this.$route.params.base

      let apk = localStorage.getItem(this.base)
      if (typeof this.$route.params.prevent !== 'undefined') {
        this.prevent = true
        localStorage.setItem(this.base, moment().format('YYYY-MM-DD'))
        window.router.replace('/client/apk/' + this.base)
      } else if (apk && apk === moment().format('YYYY-MM-DD')) {
        this.prevent = true
      } else {
        this.prevent = false
      }

      api.get('/client/apk/' + this.base, {}, function (data) {
        self.client = data
        self.uid = self.client.uid
        console.log(self.client)
      })
    }
  },
  methods: {
    selectedInsurancesTypes (selectedInsurances) {
      this.agree = 2
      this.insurances = selectedInsurances
    },
    nextStep () {
      tippy('[data-tippy-content]')
      if (this.agree === 0 || this.agree === null) {
        this.agree = 1
      } else if (this.agree === 1) {
        this.agree = 1
      }
    },
    clear () {
      this.agree = 0
      this.insurances = []
    }
  }
}
</script>
